import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import Home from './views/Home.vue'
import Main from './views/Main.vue'

// 会员管理
import MemberList from './views/MemberManagement/MemberList.vue'
import Consumption from './views/MemberManagement/Consumption.vue'
import Business from './views/MemberManagement/Business.vue'

// 基础设置
import FrequencyCard from './views/BasicSetting/FrequencyCard.vue'
import MonthCard from './views/BasicSetting/MonthCard.vue'
import RechargeableCard from './views/BasicSetting/RechargeableCard.vue'
import TrainingCard from './views/BasicSetting/TrainingCard.vue'
import YearCard from './views/BasicSetting/YearCard.vue'
import RechargeableCardConsumption from './views/BasicSetting/RechargeableCardConsumption.vue'

// 微信相关
import OAuth from './views/WeiXin/OAuth.vue'
import WeiXinMain from './views/WeiXin/WeiXinMain.vue'
import WeiXinSett from './views/BasicSetting/WeiXinSett.vue'

// import user from './views/MemberManagement/user.vue'
import ShopInfo from './views/ShopManagement/ShopInfo.vue'
import ShopUser from './views/ShopManagement/ShopUser.vue'
// import Page6 from './views/nav3/Page6.vue'
import echarts from './views/charts/echarts.vue'
import ShopList from './views/ShopManagement/ShopList.vue'
import Authority from './views/Authority.vue'



let routes = 
     [
        {
            path: '/login',
            component: Login,
            name: '',
            hidden: true
        },
        {
          path:'/',
          component: Home,
          hidden: true
        },

     

        // {
        //     path: '/',
        //     component: Home,
        //     name: '会员管理',
        //     iconCls: 'fa fa-id-card-o',//图标样式class
        //     children: [
        //         { path: '/main', component: Main, name: '主页', hidden: true },
        //         { path: '/Authority', component: Authority, name: '无访问权限', hidden: true },
        //         { path: '/MemberList', component: MemberList, name: '会员基本信息' },
        //         { path: '/Business', component: Business, name: '业务办理' },
        //         // { path: '/user', component: user, name: '列表' },
        //         { path:'/Consumption',component:Consumption,name:'消费业务'}
        //     ]
        // },
        // {
        //     path: '/',
        //     component: Home,
        //     name: '门店管理',
        //     iconCls: 'el-icon-message',
        //     children: [
        //         { path: '/Shop', component: Main, name: '主页', hidden: true },

        //         // 租主使用
        //         { path:'/ShopList',  component: ShopList, name:'门店列表'},
        //         // 门店使用
        //         { path: '/ShopInfo', component: ShopInfo, name: '门店信息' },
        //         // 租主使用
        //         { path: '/ShopUser', component: ShopUser, name: '门店账号' }

        //     ]
        // },
     
        // {
        //     // 门店使用
        //     path: '/',
        //     component: Home,
        //     name: '基础设置',
        //     iconCls: 'fa fa-bar-chart',
        //     children: [
        //         { path: '/FrequencyCard', component: FrequencyCard, name: '次卡' },
        //         { path: '/MonthCard', component: MonthCard, name: '月卡' },
        //         { path: '/YearCard', component: YearCard, name: '年卡' },
        //         { path: '/RechargeableCard', component: RechargeableCard, name: '充值卡' },
        //         { path: '/TrainingCard', component: TrainingCard, name: '培训卡' },
        //         { path: '/RechargeableCardConsumption', component: RechargeableCardConsumption, name: '充值卡消费项目' },
        //         // { path: '/WeiXinSett', component: WeiXinSett, name: '微信基础设置' }


        //     ]
        // },
        {
            path: '/OAuth',
            component: OAuth,
            name: '微信回调页',
            hidden: true

        },
        {
            path: '/WeiXinMain',
            component: WeiXinMain,
            name: '微信入口页',
            hidden: true

        },
       
       
    ]
    ;
 


export default routes;


// WEBPACK FOOTER //
// ./src/routes.js